/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetSlackIdentityMappingRequestBody = {
  /**
   * Membership to change.
   */
  id: string;
  /**
   * Mapping revision shown in the review dialog.
   */
  mappingRevision: number;
  /**
   * Directory evidence shown in the review dialog.
   */
  observationToken: string;
  /**
   * Active same-organization person to confirm. Omit to unmap.
   */
  userId?: string | undefined;
};

/** @internal */
export type SetSlackIdentityMappingRequestBody$Outbound = {
  id: string;
  mapping_revision: number;
  observation_token: string;
  user_id?: string | undefined;
};

/** @internal */
export const SetSlackIdentityMappingRequestBody$outboundSchema: z.ZodMiniType<
  SetSlackIdentityMappingRequestBody$Outbound,
  SetSlackIdentityMappingRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    mappingRevision: z.int(),
    observationToken: z.string(),
    userId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mappingRevision: "mapping_revision",
      observationToken: "observation_token",
      userId: "user_id",
    });
  }),
);

export function setSlackIdentityMappingRequestBodyToJSON(
  setSlackIdentityMappingRequestBody: SetSlackIdentityMappingRequestBody,
): string {
  return JSON.stringify(
    SetSlackIdentityMappingRequestBody$outboundSchema.parse(
      setSlackIdentityMappingRequestBody,
    ),
  );
}
